/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import DataTable from 'react-data-table-component'
import {Link} from 'react-router-dom'
import {useUser} from '../../modules/newauth/UserContext'
import firebase from '../../firebase/FirebaseConfig'
import axios from 'axios'
import Swal from 'sweetalert2'
import {AddDeviceNoteModal} from './component/AddDeviceNoteModal'
import {DeviceNoteDetailModal} from './component/DeviceNoteDetailModal'
import clsx from 'clsx'
import {NoteWidget} from './component/NoteWidget'

const DeviceNoteWrapper = () => {
  const {user} = useUser()
  const db = firebase.firestore()
  const [deviceNoteData, setDeviceNoteData] = useState([])
  const [searchTerm, setSearchTerm] = useState('')

  const [selectedDeviceNote, setSelectedDeviceNote] = useState(null)
  const [showModalDeviceNoteDetail, setShowModalDeviceNoteDetail] = useState(false)

  const [showMadalAddDeviceNote, setShowMadalAddDeviceNote] = useState(false)
  const [trigger, setTrigger] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

  const [activeView, setActiveView] = useState(() => {
    return localStorage.getItem('activeViewDeviceNote') || 'table'
  })

  const handleToggle = (view) => {
    setActiveView(view)
    localStorage.setItem('activeViewDeviceNote', view)
  }

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768)
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    async function fetchData() {
      let data = []
      await db
        .collection('deviceNotes')
        .where('createdBy', '==', user?.userId)
        .orderBy('createdAt', 'desc')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            data.push({docId: doc.id, ...doc.data()})
          })
        })

      setDeviceNoteData(data)
    }

    if (user) {
      fetchData()
    }
  }, [trigger])

  const columns = isMobile
    ? [
        {
          name: 'Device ID',
          selector: (row) => row.deviceId,
          sortable: true,
          cell: (row) => {
            return <p className='fw-semibold'>{row.deviceId}</p>
          },
        },
        {
          name: 'Device Name',
          selector: (row) => row.deviceName,
          sortable: true,
          cell: (row) => {
            return <p className='fw-semibold'>{`${row.deviceName}`}</p>
          },
        },
        {
          name: 'Action',
          selector: (row) => row.userId,
          sortable: true,
          cell: (row) => {
            return (
              <div
                className='btn btn-secondary btn-sm'
                onClick={() => {
                  setShowModalDeviceNoteDetail(true)
                  setSelectedDeviceNote(row)
                }}
              >
                Options
              </div>
            )
          },
        },
      ]
    : [
        {
          name: 'Device ID',
          selector: (row) => row.deviceId,
          sortable: true,
          cell: (row) => {
            return <p className='fs-7 fw-semibold'>{row.deviceId}</p>
          },
        },
        {
          name: 'Device Name',
          selector: (row) => row.deviceName,
          sortable: true,
          cell: (row) => {
            return (
              <>
                <p className='fs-5 fw-semibold mt-3'>{`${row.deviceName}`}</p>
              </>
            )
          },
        },
        {
          name: 'Note',
          selector: (row) => row.note,
          sortable: true,
          cell: (row) => {
            return <p className='fw-semibold'>{`${row.note}`}</p>
          },
        },
        {
          name: 'Action',
          selector: (row) => row.userId,
          sortable: true,
          cell: (row) => {
            return (
              <div
                className='btn btn-secondary btn-sm'
                onClick={() => {
                  setShowModalDeviceNoteDetail(true)
                  setSelectedDeviceNote(row)
                }}
              >
                Options
              </div>
            )
          },
        },
      ]

  const filteredData = deviceNoteData.filter(
    (user) =>
      user?.deviceId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.deviceName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.docId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.note?.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <>
      <div className='d-flex flex-wrap flex-stack mb-6'>
        <h3 className='fw-bolder my-2'>Device Notes</h3>

        <div className='d-flex my-2'>
          <ol className='breadcrumb text-muted fs-6 fw-bold'>
            <li className='breadcrumb-item pe-3'>
              <Link to={'/dashboard'} className='pe-3'>
                Dashboard
              </Link>
            </li>
          </ol>
        </div>
      </div>

      <div className='card mb-5 mb-xl-5'>
        <div className='card-header border-0 pt-2 d-flex justify-content-between align-items-center mb-3'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>
              Device Notes ({filteredData.length})
            </span>
          </h3>

          <div className='d-flex flex-column flex-md-row gap-3 w-100 w-md-auto'>
            <div className='btn-group w-100 w-md-auto' role='group'>
              <button
                type='button'
                className={clsx('btn btn-sm w-100 w-md-auto', {
                  'btn-primary text-white': activeView === 'table',
                  'btn-secondary': activeView !== 'table',
                })}
                onClick={() => handleToggle('table')}
              >
                <i className='bi bi-table'></i> Table
              </button>
              <button
                type='button'
                className={clsx('btn btn-sm w-100 w-md-auto', {
                  'btn-primary text-white': activeView === 'card',
                  'btn-secondary': activeView !== 'card',
                })}
                onClick={() => handleToggle('card')}
              >
                <i className='bi bi-grid'></i> Card
              </button>
            </div>

            <div className='w-100 w-md-auto'>
              <div
                className='btn btn-sm btn-primary w-100 w-md-auto'
                onClick={() => setShowMadalAddDeviceNote(true)}
              >
                Create new device note
              </div>
            </div>
          </div>
        </div>
      </div>

      {activeView === 'card' && (
        <>
          <div className='card mb-5 mb-xl-5'>
            <div className='card-header border-0 pt-2 d-flex justify-content-between align-items-center'>
              <div className='mt-5'>
                {/* <span className='badge badge-success badge-circle w-10px h-10px mt-1 me-3'></span> */}
                <span className='text-gray-600 me-2'>
                  {/* Last Update: {getTimeFormat(lastUpdatedTime.getTime() / 1000)} */}
                </span>
              </div>

              <div className='input-group w-lg-auto mt-3 mb-3'>
                <span className='input-group-text'>
                  <i className='fas fa-search'></i>
                </span>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Search...'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className='card-body py-3 mb-5'>
              <div className='row g-5'>
                {filteredData.map((data) => {
                  return (
                    <div className='col-xl-4 col-lg-6 col-md-6 col-12' key={data?.id}>
                      <NoteWidget
                        className='card-xl-stretch mb-xl-8  h-100'
                        data={data}
                        setShowModalDeviceNoteDetail={setShowModalDeviceNoteDetail}
                        setSelectedDeviceNote={setSelectedDeviceNote}
                      />
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </>
      )}

      {activeView === 'table' && (
        <div className='card mb-5 mb-xl-10'>
          <div className='card-header border-0 pt-2 d-flex justify-content-between align-items-center'>
            {/* Search Input & Button */}
            <div className='d-flex gap-2'>
              <h3 className='card-title align-items-start flex-column'>
                {/* <span className='card-label fw-bold fs-3 mb-1'>
                  Device Notes ({filteredData?.length})
                </span> */}
              </h3>
            </div>

            <div className='d-flex gap-3'>
              <div className='input-group w-100 w-md-auto'>
                <span className='input-group-text'>
                  <i className='fas fa-search'></i>
                </span>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Search...'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className='card-body border-top py-3'>
            <div className='table-responsive' style={{borderRadius: '10px'}}>
              <DataTable
                columns={columns}
                data={Array.isArray(filteredData) ? filteredData : []}
                pagination
                paginationPerPage={25}
                paginationRowsPerPageOptions={[25, 50, 100]}
                defaultSortFieldId='Email'
                defaultSortAsc={false}
              />
            </div>
          </div>
        </div>
      )}

      <AddDeviceNoteModal
        showMadalAddDeviceNote={showMadalAddDeviceNote}
        setShowMadalAddDeviceNote={setShowMadalAddDeviceNote}
        trigger={trigger}
        setTrigger={setTrigger}
      />

      <DeviceNoteDetailModal
        selectedDeviceNote={selectedDeviceNote}
        setSelectedDeviceNote={setSelectedDeviceNote}
        showModalDeviceNoteDetail={showModalDeviceNoteDetail}
        setShowModalDeviceNoteDetail={setShowModalDeviceNoteDetail}
        trigger={trigger}
        setTrigger={setTrigger}
      />
    </>
  )
}

function getTimeFormat(timestamp) {
  const createdAt = new Date(timestamp * 1000)
  const formattedDate = createdAt.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
  const formattedTime = createdAt.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
  const formattedDateTime = `${formattedDate} ${formattedTime}`
  return formattedDateTime
}

export {DeviceNoteWrapper}
